import { c as i } from "../../_utils/cssr/index.js";
import s from "../common/_common.js";
const {
  cubicBezierEaseInOut: n
} = s;
function l({
  name: t = "fade-in",
  enterDuration: o = "0.2s",
  leaveDuration: r = "0.2s",
  enterCubicBezier: a = n,
  leaveCubicBezier: e = n
} = {}) {
  return [i(`&.${t}-transition-enter-active`, {
    transition: `all ${o} ${a}!important`
  }), i(`&.${t}-transition-leave-active`, {
    transition: `all ${r} ${e}!important`
  }), i(`&.${t}-transition-enter-from, &.${t}-transition-leave-to`, {
    opacity: 0
  }), i(`&.${t}-transition-leave-from, &.${t}-transition-enter-to`, {
    opacity: 1
  })];
}
export {
  l as fadeInTransition
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_styles/transitions/fade-in.cssr.js
// module id = 263
// module chunks = 67